import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import { Badge } from '../ui/badge';
import { Avatar, AvatarFallback } from '../ui/avatar';
import { STAGE_LABELS, stageColors } from './lead-constants';

export function LeadViewDialog({ open, onOpenChange, lead, getOwnerName, getOwnerInitials }) {
  if (!lead) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid="lead-view-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-xl">Lead Details</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <p className="text-sm text-slate-500">Name</p>
              <p className="font-medium">{lead.first_name} {lead.last_name}</p>
            </div>
            <div>
              <p className="text-sm text-slate-500">Stage</p>
              <Badge className={`${stageColors[lead.stage]}`}>
                {STAGE_LABELS[lead.stage] || lead.stage}
              </Badge>
            </div>
            <div>
              <p className="text-sm text-slate-500">Email</p>
              <p>{lead.email || '-'}</p>
            </div>
            <div>
              <p className="text-sm text-slate-500">Phone</p>
              <p>{lead.phone || '-'}</p>
            </div>
            <div>
              <p className="text-sm text-slate-500">Owner</p>
              <div className="flex items-center gap-2">
                <Avatar className="h-6 w-6">
                  <AvatarFallback className="text-xs bg-slate-200 text-slate-600">
                    {getOwnerInitials(lead.assigned_to)}
                  </AvatarFallback>
                </Avatar>
                <span>{getOwnerName(lead.assigned_to, lead)}</span>
              </div>
            </div>
            <div>
              <p className="text-sm text-slate-500">Source</p>
              <p>{lead.source || '-'}</p>
            </div>
            <div>
              <p className="text-sm text-slate-500">Product Interest</p>
              <p>{lead.product_interest || '-'}</p>
            </div>
            <div>
              <p className="text-sm text-slate-500">Estimated Value</p>
              <p>{lead.estimated_value != null ? `$${Number(lead.estimated_value).toLocaleString()}` : '-'}</p>
            </div>
            <div>
              <p className="text-sm text-slate-500">Created</p>
              <p>{lead.created_at ? new Date(lead.created_at).toLocaleDateString() : '-'}</p>
            </div>
          </div>
          {lead.notes && (
            <div>
              <p className="text-sm text-slate-500">Notes</p>
              <p className="bg-slate-50 p-3 rounded-lg mt-1">{lead.notes}</p>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
